import { metricsService } from "../services/metricsService";
import { useAsyncData } from "./useAsyncData";

export function useAdminMetrics() {
  return useAsyncData(() => metricsService.getMetrics(), []);
}
